import styles from "./shot-map-svg-field.module.scss";
import classNames from "classnames";
import {observer} from "mobx-react";
import {ShotMapShotAnimationComposer} from "./shot-map.shot-animation.composer";
import {GAME_SHOT_CHARTS} from "../../../../widgets/game-shot-chart-widget/game-shot-charts.widget.consts";

export const ShotMapSvgField = observer(ShotMapShotAnimationComposer(({
                                                                        width,
                                                                        ratio,
                                                                        circle,
                                                                        selectedShot,
                                                                        shouldRenderAnimation,
                                                                        startPoint,
                                                                        endPoint,
                                                                        blockVector,
                                                                        isAnimationActive
                                                                      }) => {

  const height: Number = parseInt(width / ratio);

  const svgProps = {
    width,
    height,
    className: classNames(styles.field)
  }

  const circleProps = {
    cx: circle?.x,
    cy: circle?.y,
    r: GAME_SHOT_CHARTS.RADIUS.animation,
    className: classNames(styles.circle, {[styles.active]: isAnimationActive}),
  }

  const lineProps = {
    x1: startPoint?.x,
    y1: startPoint?.y,
    x2: endPoint?.x,
    y2: endPoint?.y,
    className: classNames(styles.line, {[styles.active]: isAnimationActive}),
  }

  const blockLineProps = {
    x1: blockVector?.x1,
    y1: blockVector?.y1,
    x2: blockVector?.x2,
    y2: blockVector?.y2,
    className: classNames(styles.block, {[styles.active]: isAnimationActive}),
  }

  return (
    shouldRenderAnimation && selectedShot !== null ? <svg {...svgProps}>
      <circle {...circleProps}/>
      <line {...lineProps}/>
      <line {...blockLineProps}/>
    </svg> : null
  )
}));
